import type { VoucherForCampaignUserItemInput } from "@/lib/gql/__generated__/graphql";

/**
 * CSVの一行を引数に指定すると、
 * ""で囲まれた内部のコンマを分割せずに、
 * コンマで分割して配列の戻り値を返す関数
 * @param {string} line 文字列
 * @return {Array<string>} 配列
 */
export function csvSplit(line: string): Array<string> {
	const targetLine = line + ",";
	let c = "";
	let s = new String();
	const data = [];
	let singleQuoteFlg = false;

	for (let i = 0; i < targetLine.length; i++) {
		c = targetLine.charAt(i);
		if (c === "," && !singleQuoteFlg) {
			data.push(s.toString());
			s = "";
		} else if (c === "," && singleQuoteFlg) {
			s = s.toString() + c;
		} else if (c === '"') {
			singleQuoteFlg = !singleQuoteFlg;
		} else {
			s = s.toString() + c;
		}
	}
	return data;
}

export async function csvParser(file: File): Promise<VoucherForCampaignUserItemInput[]> {
	return await file.text().then((csv) => {
		const array = csv.split("\n");
		const headerRowIndex = array.findIndex((item) => item.includes("名前"));
		const header = array[headerRowIndex].split(",").map((item) => item.replaceAll("\r", ""));
		const body = array.slice(headerRowIndex + 1).map((arr) => csvSplit(arr));

		const guestNameIndex = header.indexOf("名前");
		const guestEmailIndex = header.indexOf("メールアドレス");
		const guestTelIndex = header.indexOf("電話番号");

		const data: VoucherForCampaignUserItemInput[] = body
			.map((item) => {
				const guestName = item[guestNameIndex];
				const guestEmail = (item[guestEmailIndex] || "").replaceAll("\r", "") || null;
				const guestTel = item[guestTelIndex] || "_";

				return {
					guestName,
					guestEmail,
					guestTel,
				} satisfies VoucherForCampaignUserItemInput;
			})
			.filter((item) => item.guestName);

		return data;
	});
}
